import { faBed } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLCode from "components/common/HTMLCode";
import If from "components/common/If";

type RoomTypeViewPropsType = {
    color?: string | null
    name: string;
    showIcon?: boolean;
}

const RoomTypeView = (props: RoomTypeViewPropsType) => {
    return (
        <span className="badge badge-pill p-1" style={{ color: props.color || 'transparent'}}>
            <If condition={props.showIcon}>
                <FontAwesomeIcon icon={faBed} />
                <HTMLCode />
            </If>
            {props.name}
        </span>
    );
};

export default RoomTypeView;
